<template>
  <div :class="['login-content', { '-warn-explorer' : warnExplorer && isDesktop }]">
    <!-- left-side -->
    <div
      data-cy="company-login-bg-image"
      :class="['left', { '-warn-explorer' : warnExplorer && isDesktop }]"
      :style="{ backgroundImage: `url(${config.background || placeholder()})` }"
    >
      <c-image
        v-if="accountSlug === 'pic-itau-r4g'"
        class="itau-logo"
        :src="itauLogo"
      />
    </div>

    <!-- right-side -->
    <div :class="['right', { '-warn-explorer' : warnExplorer && isDesktop }]">
      <slot
        :companyProps="company"
        :configProps="config"
      />
    </div>
    <!-- footer -->
    <footer-component
      class="footer"
      :partners="config.partners || []"
      :hide-developed="hideDeveloped"
    />
  </div>
</template>

<script>
import * as types from '@store/types'
import { mapGetters } from 'vuex'

import FooterComponent from '@/components/Login/FooterComponent'

export default {
  components: { FooterComponent },
  props: {
    accountSlug: String,
    warnExplorer: Boolean
  },
  data () {
    return {
      placeholder: () => require('@/assets/img/login_bg.png'),
      itauLogo: require('@/assets/img/itau_logo.png')
    }
  },
  computed: {
    ...mapGetters({
      config: types.CONFIG_SIGNIN,
      company: types.COMPANY
    }),
    hideDeveloped () {
      return (this.config || {}).developedByConvenia === false
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

.login-content {
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  &.-warn-explorer {
    min-height: auto;
  }
  & > .left {
    display: none;

    @include desktop {
      position: relative;
      display: block;
      width: calc(100% - 420px);
      height: calc(100vh - 85px);
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      &.-warn-explorer {
        height: calc(100vh - 165px);
      }
    }

    & > .itau-logo {
      position: absolute;
      right: 0px;
      width: 70px;
      margin: 15px;
    }
  }

  & > .right {
    width: 100vw;
    height: 100%;
    overflow-y: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px 40px;
    background-color: $signIn-background-placeholder;
    background-color: var(--signIn-background);

    @include mobile{
      min-height: 100vh;
    }

    @include desktop {
      width: 420px;
      height: calc(100vh - 85px);
      max-width: 100%;

      &.-warn-explorer {
        height: calc(100vh - 165px);
      }
    }

    .validation {
      color: $signIn-negativeFeedback-placeholder;
      color: var(--signIn-negativeFeedback) !important;

      & > .icon {
        fill: $signIn-negativeFeedback-placeholder;
        fill: var(--signIn-negativeFeedback) !important;
      }
    }

    .btn-main {
      background-color: $signIn-mainButton;
      background-color: var(--signIn-mainButton) !important;
      &:hover {
         background-color: rgba($signIn-mainButton, .8);
         background-color: var(--color-primary-8) !important;
      }
      & > .text {
        color: $signIn-mainButtonText;
        color: var(--signIn-mainButtonText);
      }
    }

    .btn-secondary {
      &:not(:hover) {
        border-color: $signIn-secondaryButton;
        border-color: var(--signIn-secondaryButton) !important;
        }
      & > .text {
        color: $signIn-secondaryButton;
        color: var(--signIn-secondaryButton);
      }
    }
  }

  & > .footer {
    display: none;

    @include desktop {
      padding-left: 0;
      display: flex;
      width: 100%;
      min-height: 80px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginTemplate.vue